function setCookie(cname, cvalue) {
  var maxAge = 365 * 24 * 60 * 60;

  document.cookie = cname + "=" + (cvalue || "") + ";max-age=" + maxAge +";domain=;path=/";
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : ""
}

$("body").on("click", ".filter_item_bookmark", function () {
  let bookmark = $(this);
  $.ajax({
    type: "PUT",
    url: Routes.filter_path(bookmark.data("id")),
    data: {
      authenticity_token: $("meta[name=csrf-token]").prop("content"),
      is_saved: !bookmark.hasClass("active")
    }
  }).done(function (response) {
    bookmark.toggleClass("active");
  }).fail(function (errorThrown) {
  });
});

$("body").on("click", ".filter_item_close", function () {
  let item = $(this);
  if (item.data("search_id")) {
    search_histories = JSON.parse(localStorage.getItem('search_histories'));
    $.each(search_histories, function( index, value ) {
      if (value["id"] == item.data("search_id")) {
        search_histories.splice( $.inArray(value, search_histories), 1 );
        return false;
      }
    });
    localStorage.setItem('search_histories', JSON.stringify(search_histories));
    $(".filter_pagination").text(`検索履歴 ${search_histories.length}件 を表示中`);
    item.closest(".filter_item").remove();
    $(".js-search-count").text($(".filter_item").length);
    if ($(".filter_item").length == 0){
      $(".js-filter-content").html("検索履歴はありません");
    }
  } else {
    $.ajax({
      type: "DELETE",
      url: Routes.filter_path(item.data("id")),
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        bookmark: item.data("bookmark")
      }
    }).done(function (response) {
      item.closest(".filter_item").remove();
      $(".js-search-count").text($(".filter_item").length);
      if ($(".filter_item").length == 0){
        $(".js-filter-content").html("検索履歴はありません");
      }
    }).fail(function (errorThrown) {
    });
  }
});

$("body").on("click", ".filter_trash", function () {
  if ($(this).data("bookmark")) {
    $.ajax({
      type: "DELETE",
      url: Routes.destroy_all_filters_path(),
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        bookmark: $(this).data("bookmark")
      }
    }).done(function (response) {
      $(".js-filter-content").html("検索履歴はありません");
    }).fail(function (errorThrown) {
    });
  } else {
    localStorage.removeItem('search_histories');
    $(".js-filter-content").html("検索履歴はありません");
  }
});

$(document).ready(function () { 
  if ($("#check_user_signed_in").val() == 'false') {
    search_histories = JSON.parse(localStorage.getItem('search_histories'));
    if (search_histories == null) {
      $(".js-filter-content").html("検索履歴はありません");
    }else {
      $(".filter_pagination").append(`検索履歴 ${search_histories.length}件 を表示中`);
      $.ajax({
        type: "GET",
        url: Routes.ajax_job_counter_filters_path(),
        data: {
          search_params: search_histories
        },
      }).done(function (response) {
        let container = $('.filter_item_list');
        container.empty();
        $.each( response["result"].reverse(), function( key, value ) {
          let div1 = $('<div>').addClass('filter_item');
          let div2 = $('<div>').addClass('filter_item_container');
          let div3 = $('<div>').addClass('filter_item_search-content');
          let div4 = $('<div>').addClass('filter_item_name');
          let a = $('<a>', {
            href: encodeURI(value['url']),
            text: (value['title'])
          });
          div4.append(a);
          let div5 = $('<div>')
            .addClass('filter_item_close')
            .attr('data-search_id', encodeURI(value['id']));
          let img = $('<img>', {
            src: '/assets/icons/close-black-4e5868bdb6b9ee325b9c452234a3960406c93432721e625b52655a2e4bb0f794.svg'
          });
          div5.append(img);
          let div6 = $('<div>')
            .addClass('filter_item_scale')
            .text(`${encodeURI(value['count_job'])}件の案件・求人`);
          div3.append(div4, div5);
          div2.append(div3, div6);
          div1.append(div2);
          container.append(div1);
        });
      }).fail(function (errorThrown) {
      });
    };
  };
});

$("body").on("click", ".filter_item_name", function (e) {
  e.preventDefault();
  
  const encodedUrl = this.firstChild.getAttribute('href');
  const decodedUrl = decodeURIComponent(encodedUrl);
  
  window.location.href = decodedUrl;
});
